module.exports = __webpack_public_path__ + "img/bottomList0_active.47e3fb19.svg";